var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.Verification)?_c('el-button',{on:{"click":_vm.btnClick}},[_vm._v("获取验证码")]):(!_vm.Verification)?_c('el-button',[_c('span',[_vm._v(_vm._s(_vm.timer))]),_vm._v("秒后重新获取")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }